import React from 'react';
//components
import { Row } from 'components/Layout/Grid';
import Text from 'components/Text';
//assets
import "./style.scss";

interface EmptyDataMessageProps {
  valueLineOne?: string;
  valueLineTwo?: string;
}

export const EmptyDataMessage: React.FC<EmptyDataMessageProps> = ({ valueLineOne, valueLineTwo }) => {
  return (
    <Row className="d-flex flex-column align-center justify-center empty-data mt-2">
        <Text size={24} color={'#5B5B5B'} weight={700}>{valueLineOne}</Text>
        <Text size={24} color={'#5B5B5B'} weight={700}>{valueLineTwo}</Text>
    </Row>
  );
};